import { render, staticRenderFns } from "./YandexAd.vue?vue&type=template&id=6acc4710"
import script from "./YandexAd.vue?vue&type=script&lang=js"
export * from "./YandexAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports